import { OrderFailReason } from '@bts-web/data-layer/server';

export const orderFailReasonTranslationKeys: Record<OrderFailReason, string> = {
  CANCELLED_BY_USER: 'notifications.order.canceled.user_canceled.title',
  EXPIRED: 'notifications.order.canceled.expired.title',
  CANCELLED_DUE_TO_ASSET_DISABLING:
    'notifications.order.failed.asset_disabled.title',
  ORDER_EXECUTION_ERROR: 'notifications.order.failed.internal_error.title',
  SLIPPAGE_EVALUATION: 'notifications.order.failed.internal_error.title',
  USER_ACCOUNT_INACTIVE: 'notifications.order.failed.internal_error.title',
  USER_TRANSACTION_INACTIVE_CRYPTOCOIN:
    'notifications.order.failed.internal_error.title',
  USER_TRANSACTION_OPERATIONS_DISABLED:
    'notifications.order.failed.internal_error.title',
  USER_TRANSACTION_TRADING_DISABLED:
    'notifications.order.failed.internal_error.title',
};
